/**
 * Chart color scheme for dark theme - high contrast
 * Shared across all insight visualizations
 */
export const chartColors = {
  primary: '#3b82f6',      // Blue
  danger: '#ef4444',       // Red
  warning: '#f59e0b',      // Amber
  success: '#10b981',       // Green
  purple: '#a855f7',       // Purple
  gray: '#6b7280',         // Gray
  text: '#e5e7eb',         // Light gray text
  textSecondary: '#9ca3af', // Medium gray text
  grid: '#4b5563',         // Grid lines
  background: '#1f2937',   // Chart background
};



